import { render, staticRenderFns } from "./AttachmentListItemGroup.vue?vue&type=template&id=6a49184a&lang=pug"
import script from "./AttachmentListItemGroup.vue?vue&type=script&lang=ts"
export * from "./AttachmentListItemGroup.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentListItemGroup.vue?vue&type=style&index=0&id=6a49184a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports